/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExecRiskScanStatus } from './ExecRiskScanStatus';
import {
    ExecRiskScanStatusFromJSON,
    ExecRiskScanStatusFromJSONTyped,
    ExecRiskScanStatusToJSON,
} from './ExecRiskScanStatus';

/**
 * 
 * @export
 * @interface ExecRiskProcessStatusResponse
 */
export interface ExecRiskProcessStatusResponse {
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProcessStatusResponse
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProcessStatusResponse
     */
    status?: string;
    /**
     * 
     * @type {ExecRiskScanStatus}
     * @memberof ExecRiskProcessStatusResponse
     */
    scan_status?: ExecRiskScanStatus;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProcessStatusResponse
     */
    started: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProcessStatusResponse
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof ExecRiskProcessStatusResponse
     */
    finished?: string;
}

/**
 * Check if a given object implements the ExecRiskProcessStatusResponse interface.
 */
export function instanceOfExecRiskProcessStatusResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "started" in value;

    return isInstance;
}

export function ExecRiskProcessStatusResponseFromJSON(json: any): ExecRiskProcessStatusResponse {
    return ExecRiskProcessStatusResponseFromJSONTyped(json, false);
}

export function ExecRiskProcessStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecRiskProcessStatusResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'process_id': json['process_id'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'scan_status': !exists(json, 'scan_status') ? undefined : ExecRiskScanStatusFromJSON(json['scan_status']),
        'started': json['started'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'finished': !exists(json, 'finished') ? undefined : json['finished'],
    };
}

export function ExecRiskProcessStatusResponseToJSON(value?: ExecRiskProcessStatusResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'process_id': value.process_id,
        'status': value.status,
        'scan_status': ExecRiskScanStatusToJSON(value.scan_status),
        'started': value.started,
        'updated': value.updated,
        'finished': value.finished,
    };
}

